/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { ContainerProps } from './types';
import { generateID } from '../../base/helper';

/**
 * Space should be limited to 1-8.
 * @param spacing
 * @returns
 */
const getSpaceClass = (spacing?: number) => {
  const sp = Math.floor(spacing ?? 0);
  return sp >= 1 && sp <= 8 ? `${sp}` : '';
};

const getLayoutClasses = (
  spacing?: number | { sm?: number; md?: number },
  rowSpacing?: number | { sm?: number; md?: number }
) => {
  let classes = '';
  if (typeof spacing === 'number') {
    classes += ` grid-spacing-sm-${getSpaceClass(spacing)} grid-spacing-md-${getSpaceClass(spacing)}`;
  } else if (spacing) {
    classes += ` grid-spacing-sm-${getSpaceClass(spacing.sm)} grid-spacing-md-${getSpaceClass(spacing.md)}`;
  }
  if (typeof rowSpacing === 'number') {
    classes += ` grid-row-spacing-sm-${getSpaceClass(rowSpacing)} grid-row-spacing-md-${getSpaceClass(rowSpacing)}`;
  } else if (rowSpacing) {
    classes += ` grid-row-spacing-sm-${getSpaceClass(rowSpacing.sm)} grid-row-spacing-md-${getSpaceClass(rowSpacing.md)}`;
  }
  return classes;
};

/**
 * Container of Grid
 * @public
 */
const Container: React.FC<ContainerProps> = (props) => {
  const { id = generateID(), children, spacing, rowSpacing } = props;
  const className = getLayoutClasses(spacing, rowSpacing);

  return (
    <div
      id={id}
      className={`clientos-ui-toolkit-grid-container ${className}`}
    >
      {children}
    </div>
  );
};

export default memo(Container);
